import { actions, IModalMode } from '~/redux/reducers';


/** modal */
export interface PayloadModalOpen {
  content: React.ReactElement | string;
  mode?: IModalMode;
}
export function openModal(payload: PayloadModalOpen) {
  return {
    type: actions.OPEN_MODAL,
    payload: { mode: 'normal', ...payload },
  };
}

export function closeModal() {
  return {
    type: actions.CLOSE_MODAL,
  };
}

/** resources */
export type PayloadFavouriteResource = number;
export function addResourceFav(payload: PayloadFavouriteResource) {
  return {
    type: actions.ADD_RESOURCE_FAV,
    payload,
  };
}
export function removeResourceFav(payload: PayloadFavouriteResource) {
  return {
    type: actions.REMOVE_RESOURCE_FAV,
    payload,
  };
}
export function toggleResourceFav(payload: PayloadFavouriteResource) {
  return {
    type: actions.TOGGLE_RESOURCE_FAV,
    payload,
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/index.ts